import reducer from './reducer';
import * as actions from './reducer';

export { actions };

export default reducer;
